import styled from '@emotion/styled';

export const MainBlock = styled.div`
  padding: 24px;
`;

export const Intro = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.AccentCornsilk};
  color: ${({ theme }) => theme.colors.Black24};
  font-family: 'SF Pro Text', sans-serif;
  font-size: 13px;
  line-height: 18px;
  max-width: 900px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  align-items: start;
`;

export const Card = styled.section`
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  border: 1px solid ${({ theme }) => theme.colors.WhiteGray20};
`;

export const CardTitle = styled.div`
  font-family: 'SF Pro Text', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.DarkBlue};
`;

export const CardKind = styled.div`
  margin-top: 4px;
  font-family: 'SF Pro Text', sans-serif;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.Gray};
`;

export const CardSource = styled.div`
  margin-top: 8px;
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 11px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.Gray};
  white-space: pre-wrap;
`;

export const CardAction = styled.div`
  margin-top: 12px;
`;
